<template>
	<div class="team-talk">
		<div v-show="isTeamListShowed" class="left-sidebar">
			<div class="team-list">
				<div v-for="(row, index) in teams" :key="index" @click="onClickTeam(row)" class="team horizontal-center" :class="{current: isCurrentTeam(row.id)}">
					<div class="avatar">
						<avatar :image="row.image" :isTeam="true" :width="55"></avatar>
					</div>
					<span class="bold18 team-name" v-html="$utils.ellipsis(row.name, 30)"></span>
					<div class="message-unread-label"><span v-show="unreadMessageCounts[row.id] > 0">未読</span></div>
				</div>
			</div>
		</div>

		<div v-show="isRoomShowed" class="room" :style="roomStyle">
			<team-talk-room-component :team="currentTeam" :teams="teams" :isRoomShowed="isRoomShowed" @update-read="onUpdateRead" @message-loading-change="onMessageLoadingChange"/>
		</div>
		<div v-if="$utils.isApp()">
			<loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
		</div>
		<div v-else>
			<b-loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></b-loading>
		</div>
	</div>
</template>

<script>
import Avatar from '@/components/Avatar'
import TeamTalkRoomComponent from '@/components/TeamTalkRoomComponent'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
	name: 'TeamTalk',
	components: {
		Avatar,
		TeamTalkRoomComponent,
		Loading,
	},
	props: {
	},
	data () {
		return {
			teams: [],
			unreadMessageCounts: {},
			currentTeam: null,
			isTeamListShowed: true,
			isRoomShowed: true,
			isLoading: false,
		}
	},
	created() {
	},
	mounted() {
		this.init();
	},
	watch: {
		'$route' (to, from) {
			this.setCurrentTeam(this.$route.params.teamId);
			this.setLayout();
		},
		'unreadMessageCount': function(count) {
			if (count > 0) {
				for (var i = 0; i < this.teams.length; i++) {
					this.getUnreadMessageCountByTeam(this.teams[i].id);
				}
			}
		}
	},
	computed: {
		roomStyle: function() {
			let adjust = this.$utils.isApp() ? 30 : 150;
			let style = {'height': 'calc(100vh - ' + adjust + 'px)'};
			return style;
		},
		...mapState([
			'unreadMessageCount',
		]),
	},
	methods: {
		onUpdateRead: function(teamId) {
			this.getUnreadMessageCount();
			this.getUnreadMessageCountByTeam(teamId);
		},
		onMessageLoadingChange(isLoading) {
			this.isLoading = isLoading;
		},
		init: function() {
			this.setLayout();
			this.getData();
		},
		setLayout: function() {
			if (this.isPC()) {
				this.isTeamListShowed = true;
				this.isRoomShowed = true;
			}
			else {
				if (this.$route.params.teamId) {
					this.isTeamListShowed = false;
					this.isRoomShowed = true;
				}
				else {
					this.isTeamListShowed = true;
					this.isRoomShowed = false;
				}
			}
		},
		getData: async function() {
			this.isLoading = true;
			try {
				this.teams = await this.getTeams();
				this.getUnreadMessageCounts(this.teams);
				if (this.isPC()) {
					this.setCurrentTeam(this.$route.params.teamId);
				}
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
		getTeams: async function() {
			let ep = 'TeamTalk/getTeams';
			// this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				// this.$utils.log(res.data.teams);
				return res.data.teams;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			}
		},
		setCurrentTeam: function(teamId) {
			if (teamId) {
				this.currentTeam = this.teams.find((team) => {
					return (team.id === teamId);
				});
			}
			if (!this.currentTeam) this.currentTeam = this.teams[0];
		},
		getUnreadMessageCounts: function(teams) {
			this.getUnreadMessageCount();
			for (var i = 0; i < teams.length; i++) {
				this.getUnreadMessageCountByTeam(teams[i].id);
			}
		},
		getUnreadMessageCount: async function() {
			let ep = 'TeamTalk/getUnreadMessageCount';
			// this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				// this.$utils.log(res);
				this.$store.commit('updateUnreadMessageCount', res.data.count);
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
			}
		},
		getUnreadMessageCountByTeam: async function(teamId) {
			let ep = 'TeamTalk/getUnreadMessageCount?team_id=' + teamId;
			// this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				// this.$utils.log('count = '+res.data.count);
				this.$set(this.unreadMessageCounts, teamId, res.data.count);
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			}
		},
		onClickTeam: function(team) {
			this.$router.push({ name: 'team-talk-view', params: { teamId: team.id, token: this.$consts.DUMMY_TOKEN }});
		},
		isPC: function() {
			if (this.$utils.isSp() || this.$utils.isApp()) {
				return false;
			}
			return true;
		},
		isCurrentTeam: function(teamId) {
			if (this.currentTeam) {
				return this.currentTeam.id==teamId;
			}
			return false;
		},
	}
}
</script>


<style lang="scss" scoped>
@import '@/scss/_vars.scss';

.team-talk {
	.team-list {
		display: flex;
		flex-direction: column;

		.team {
			padding-left: 22px;
			padding-right: 15px;
			padding-top: 8px;
			padding-bottom: 7px;
			margin-bottom: 10px;
			height: 70px;
			background: #fff;
			display: flex;
			justify-content: space-between;

			.team-name {
				width: 200px;
			}

			.message-unread-label {
				min-width: 32px;
				font-size: 16px;
				color: #FD0D1B;
			}
		}
	}

	.room {
		display: flex;
		flex-direction: column;
		width: 100%;
		background: #fff;
	}
}

@media screen and (max-width: $breakPoint - 1) {
	.team-talk {
		margin: -20px -10px -50px;

		.team-list {
			margin: 20px 10px;
		}
	}
}

@media screen and (min-width: $breakPoint) {
	$sideMargin: 120px;

	.team-talk {
		display: flex;

		.room {
			margin-left: 18px;
		}
	}

	.team-list {
		width: 375px;

		.current {
			border-width: 4px;
			border-color: #F9A841;
			border-style: solid;
		}
	}
}
</style>
